<template>
  <div class="live-indicator">
    <span class="live-indicator__pulse"></span>
    <span class="live-indicator__pulse-inner"></span>
    <span class="live-indicator__label">{{text}}</span>
  </div>
</template>

<script>
export default {
  name: 'live-indicator',
  props: {
    text: {
      type: String,
      default() { return this.$t('states.live'); },
    },
  },
  i18n: {
    messages: {
      de: {
        states: {
          live: 'Live',
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import '../theme/variables.scss';

$color: $global-success-background;
$pulse-container: 20px;
$pulse-horizontal-margin: 4px;
$pulse-radius: 14px;

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
  }
}

@keyframes pulse-inner {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 0;
    transform: scale(2);
  }
}

.live-indicator {
  display: inline-block;
  color: $color;
  position: relative;
}

.live-indicator__pulse,
.live-indicator__pulse-inner {
  display: block;
  position: absolute;
  background-color: $color;
  border-radius: 50%;
  margin: {
    left: 3px;
    right: 3px;
    top: ($pulse-container - $pulse-radius) / 2 + 1px;
    bottom: ($pulse-container - $pulse-radius) / 2 + 1px;
  }
  width: $pulse-radius;
  height: $pulse-radius;
  animation: {
    duration: 4s;
    iteration-count: infinite;
  }
}

.live-indicator__pulse {
  animation: {
    name: pulse;
    timing-function: ease-in-out;
  }
}

.live-indicator__pulse-inner {
  animation: {
    name: pulse-inner;
    timing-function: ease-in;
  }
}

.live-indicator__label {
  padding-left: $pulse-container - $pulse-horizontal-margin + 7px;
}
</style>



// WEBPACK FOOTER //
// LiveIndicator.vue?8d8583aa